<template>
  <div class="purchase-poster purchase-poster__page">
    <header class="purchase-poster__title title">
      <div class="title__text" v-show="showPlaceholderTitle === true">AI智能录音笔</div>
      <img class="title__image" v-show="showPlaceholderTitle === false" @load="showPlaceholderTitle = false" :src="require('@/assets/img/recorderPenPurchasePoster/title@1x.png')" />
    </header>
    <article class="purchase-poster__goods goods">
      <section class="goods__list list">
        <div
          v-for="(item, index) in goodsList"
          :key="index"
          class="list__item item"
        >
          <div class="item__wrapper">
            <div class="item__description">
              <h3 class="item__title">{{ item.title }}</h3>
              <section class="item__description-text" v-html="item.description" />
            </div>
            <section class="item__thumb">
              <img :src="item.thumb" :alt="item.title" :title="item.title" />
            </section>
          </div>
          <section class="item__operation">
            <vant-button
              type="primary"
              block
              @click="() => hrefTo(item.purchaseLink.jd)"
            >京东购买</vant-button>
            <!-- <vant-button
              type="primary"
              block
              @click="() => hrefTo(item.purchaseLink.tmall)"
            >天猫购买</vant-button> -->
          </section>
        </div>
      </section>
    </article>
  </div>
</template>
<script>
import { Button as VantButton } from 'vant'
export default {
  name: 'PurchasePoster',
  components: {
    VantButton
  },
  data () {
    return {
      showPlaceholderTitle: false,
      goodsList: [
        {
          title: '捷通华声M1',
          description: '既是智能AI录音笔，又是麦克风<br />终身免费文字转写',
          thumb: require('@/assets/img/recorderPenPurchasePoster/m1@1x.png'),
          purchaseLink: {
            jd: 'openapp.jdmobile://virtual?params={"category":"jump","des":"productDetail","skuId":"10047177811240","sourceType":"JSHOP_SOURCE_TYPE","sourceValue":"JSHOP_SOURCE_VALUE"}',
            tmall: 'taobao://item.taobao.com/item.htm?id=662335335920'
          }
        }
        // v1.8.0 删除A1购买链接，这里注释为了防止以后重新使用
        // {
        //   title: '捷通华声A1',
        //   description: '超高性价比，便携领夹智能AI录音笔<br />终身免费文字转写',
        //   thumb: require('@/assets/img/recorderPenPurchasePoster/a1@1x.png'),
        //   purchaseLink: {
        //     jd: 'openApp.jdMobile://virtual?params={"category":"jump","des":"productDetail","skuId":"10047181258775","sourceType":"JSHOP_SOURCE_TYPE","sourceValue":"JSHOP_SOURCE_VALUE"}',
        //     tmall: 'taobao://item.taobao.com/item.htm?id=675293179601'
        //   }
        // }
      ]
    }
  },
  methods: {
    hrefTo (link) {
      location.href = link
    }
  }
}
</script>
<style lang="scss" scoped>
.purchase-poster {
  display: flow-root;
  min-height: 100vh;
  height: fit-content;
  background-color: #0321c3;
  background-image: url('~@/assets/img/recorderPenPurchasePoster/bg@1x.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  color: #fff;
  padding-bottom: 40px;
  &__title {
    margin-top: 80px;
    .title {
      &__text{
        font-size: 72px;
      }
      &__image {
        width: 550px;
      }
    }
  }
  &__goods {
    margin: 40px auto auto;
    width: 656px;
    color: #000;
    border-radius: 40px;
    text-align: left;
    .goods {
      &__list {
        .list {
          &__item {
            box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1), 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
            background: #fff;
            padding: 50px;
            border-radius: 20px;
            &:not(:first-child) {
              margin-top: 32px;
            }
            .item {
              &__wrapper {
                display: flex;
                justify-content: space-between;
              }
              &__description {
                &-text {
                  color: #0421C3;
                  font-size: 24px;
                  line-height: 34px;
                  font-weight: 400;
                }
              }
              &__title {
                font-size: 40px;
                line-height: 44px;
                font-weight: 700;
                color: #0421C3;
                margin: 16px 0;
              }
              &__thumb {
                flex: 0 0 auto;
                width: 184px;
                background: #D8D8D8;
                border-radius: 12px;
                margin-left: 24px;
                > img {
                  width: 100%;
                }
              }
              &__operation {
                margin-top: 64px;
                ::v-deep .van-button {
                  margin-top: 32px;
                  border: 0;
                  background: linear-gradient(180deg, #fe8c08 0%, #f14277 100%);
                  border-radius: 12px;
                  height: 64px;
                  span {
                    font-size: 32px;
                    font-weight: 700;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
